import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import "react-toastify/dist/ReactToastify.css";
import { registerLocale } from "react-datepicker";
import {
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import SectionInfoTab from "./component/SectionInfoTab";
import sectionApi from "api/sectionApi";

export interface Props {
  id?: string;
  item?: any;
  triggerRefresh?: () => void;
  setIsOpen?: any;
  setItemToEdit?: any;
  dataSection?: any;
}

registerLocale("en", en);
registerLocale("ko", ko);

const SectionForm = ({
  id = "",
  item,
  triggerRefresh,
  setIsOpen,
  setItemToEdit,
  dataSection
}: Props) => {
  const { t, i18n } = useTranslation();

  // console.log(item)
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [checkedTab, setCheckedTab] = useState<number>(1);
  const [dataItemSection, setDataItemSection] = useState<any>([]);
  const [dataInfoSection, setDataInfoSection] = useState<any>(null);
  const [dataLinkedSection, setDataLinkedSection] = useState<any>(null);

  const onCloseClick = () => {
    setIsOpen(false);
    setItemToEdit(false);
  };

  const handleUpdateSuccess = async () => {
    triggerRefresh && triggerRefresh();
    onCloseClick();
  }

  useEffect(() => {
    if (item) {
      setDataInfoSection(item)
      if (item?.id && dataSection) {
        setDataLinkedSection(dataSection?.filter((s: any) => s?.value !== item?.id ))
      }else {
        setDataLinkedSection(dataSection)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]);

  useEffect(() => {
    document.title = `${id ? t("Update Section") : t("Create Section")} - ${t(
      "Section Management"
    )} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <Modal isOpen={true} centered={true} scrollable={false} size="xl">
        <ModalHeader toggle={isLoading ? () => {} : onCloseClick} className="pb-3">
          {id ? t("Update Section") : t("Create Section")}
        </ModalHeader>
        <ModalBody className="pt-0">
          <SectionInfoTab data={dataInfoSection} handleUpdateSuccess={handleUpdateSuccess} dataSection={dataLinkedSection} />
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default SectionForm;
